var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"global-message",on:{"click":_vm.showPopup}},[_vm._v(" A message to the 2GTHR community > ")]),_c('global-message-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }